var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpInitialsLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 54,
    viewBox: "0 0 69 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000895077H20.0989C23.2724 1.05873 25.9674 3.02329 28.1838 5.89456C30.4506 8.71545 31.584 12.1912 31.584 16.3218C31.584 23.0718 28.9142 28.0336 23.5746 31.2071L31.2062 52.8927H20.6278L14.2052 33.625H10.2006V52.8927H0V0.000895077ZM10.2006 9.06807V25.1623H16.6987C17.555 24.9608 18.4869 24.1045 19.4944 22.5933C20.5522 21.0317 21.0812 19.2183 21.0812 17.153C21.0812 15.0877 20.6278 13.2742 19.7211 11.7127C18.8647 10.1511 18.0084 9.26956 17.1521 9.06807H10.2006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9009 9.06715V27.957H53.6257C56.3962 25.6903 57.7815 22.3656 57.7815 17.9832C57.7815 16.1194 57.4037 14.3563 56.6481 12.694C55.9428 11.0317 55.0865 9.82275 54.079 9.06715H46.9009ZM36.663 42.1617L36.7003 0H57.177C60.6023 1.51119 63.2973 3.82836 65.2619 6.95148C67.2768 10.0746 68.2843 13.7267 68.2843 17.9076C68.2843 22.0382 67.2516 25.8666 65.1863 29.3927C63.121 32.9188 60.0734 35.4123 56.0436 36.8731H46.9009L46.8636 42.1617H36.663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6624 44.5975C36.6624 44.2652 36.9208 43.9958 37.2396 43.9958H46.1673C46.4861 43.9958 46.8856 44.2652 46.8856 44.5975V52.5597C46.8856 52.892 46.4861 53.1614 46.1673 53.1614H37.2396C36.9208 53.1614 36.6624 52.8921 36.6624 52.5598V44.5975Z",
    fill: "#FF414D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpInitialsLogoW);
export default __webpack_public_path__ + "static/media/RPInitialsLogoW.d814e491b57589b5151bbc1c987af770.svg";
export { ForwardRef as ReactComponent };